/* import __COLOCATED_TEMPLATE__ from './color-popover-editor.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { isPresent } from '@ember/utils';
import { CALLOUT_BLOCK_BACKGROUND_COLORS, CALLOUT_BLOCK_BORDER_COLORS } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
import { columnResizingPluginKey } from 'prosemirror-tables';
const defaultValue = 'default';
let ColorPopoverEditor = (_class = class ColorPopoverEditor extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "insertionPointRect", _descriptor, this);
  }
  get composer() {
    return this.args.composer;
  }
  get addDefault() {
    return defaultValue;
  }
  get initializeDomRect() {
    let currentlyActiveBlock = this.currentlyActiveBlock;
    if (!currentlyActiveBlock) {
      return new DOMRect(0, 0, 0, 0);
    }
    let activeBlockDomElement = this.composer.findDomAtDocumentPosition(currentlyActiveBlock.start).node;
    if (!activeBlockDomElement) {
      return new DOMRect(0, 0, 0, 0);
    }
    let boundingRect = activeBlockDomElement.getBoundingClientRect();
    return boundingRect;
  }
  get currentlyActiveBlock() {
    if (this.composer.state.selectionIsTableCell) {
      return this.composer.state.currentlyActiveTableCell;
    }
    return this.composer.state.currentlyActiveCallout;
  }
  get isVisible() {
    return this.composer.state.isInteractive && this.composer.state.selectionInfo.visible && (this.composer.state.selectionIsInCallout || this.canColorTableCell);
  }
  get canColorTableCell() {
    let columnResizeState = columnResizingPluginKey.getState(this.composer.state.prosemirrorState);
    let isDraggingResizeHandle = isPresent(columnResizeState?.dragging);
    return this.composer.state.selectionIsTableCell && !isDraggingResizeHandle;
  }
  setInsertionPointRect() {
    let activeBlock = this.currentlyActiveBlock;
    if (!activeBlock) {
      return;
    }
    let blockDomElement = this.composer.findDomAtDocumentPosition(activeBlock.start).node;
    if (!blockDomElement) {
      return;
    }
    this.insertionPointRect = blockDomElement.getBoundingClientRect();
  }
  updateColor(color) {
    if (this.composer.state.selectionIsTableCell) {
      this.composer.commands.styling.updateTableCellBackgroundColor(CALLOUT_BLOCK_BACKGROUND_COLORS[color]);
      this.composer.state.selectionInfo.visible = false;
    } else {
      this.composer.commands.styling.updateCalloutColor({
        backgroundColor: CALLOUT_BLOCK_BACKGROUND_COLORS[color],
        borderColor: CALLOUT_BLOCK_BORDER_COLORS[color]
      });
    }
    this.composer.commands.focus();
  }
  updateInsertionPointRect() {
    this.setInsertionPointRect();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "insertionPointRect", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.initializeDomRect;
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateColor", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateInsertionPointRect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInsertionPointRect"), _class.prototype), _class);
export { ColorPopoverEditor as default };